import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	remainingReleases: {
		id: 'portfolio-3-portfolio.app-export-view.main.view-information.filter.remaining-releases',
		defaultMessage: '+{count} {count, plural, one {more release} other {more releases}}',
		description:
			'The label to show the number of releases truncated within the export view filter information',
	},
	remainingTeams: {
		id: 'portfolio-3-portfolio.app-export-view.main.view-information.filter.remaining-teams',
		defaultMessage: '+{count} {count, plural, one {more team} other {more teams}}',
		description:
			'The label to show the number of teams truncated within the export view filter information',
	},
	remainingAssignees: {
		id: 'portfolio-3-portfolio.app-export-view.main.view-information.filter.remaining-assignees',
		defaultMessage: '+{count} {count, plural, one {more assignee} other {more assignees}}',
		description:
			'The label to show the number of assignees truncated within the export view filter information',
	},
	remainingReporters: {
		id: 'portfolio-3-portfolio.app-export-view.main.view-information.filter.remaining-reporters',
		defaultMessage: '+{count} {count, plural, one {more reporter} other {more reporters}}',
		description:
			'The label to show the number of reporters truncated within the export view filter information',
	},
	remainingIssueTypes: {
		id: 'portfolio-3-portfolio.app-export-view.main.view-information.filter.remaining-issue-types',
		defaultMessage: '+{count} {count, plural, one {more issue type} other {more issue types}}',
		description:
			'The label to show the number of issue types truncated within the export view filter information',
	},
	remainingIssuePriorities: {
		id: 'portfolio-3-portfolio.app-export-view.main.view-information.filter.remaining-issue-priorities',
		defaultMessage:
			'+{count} {count, plural, one {more issue priority} other {more issue priorities}}',
		description:
			'The label to show the number of issue priorities truncated within the export view filter information',
	},
	remainingSprints: {
		id: 'portfolio-3-portfolio.app-export-view.main.view-information.filter.remaining-sprints',
		defaultMessage: '+{count} {count, plural, one {more sprint} other {more sprints}}',
		description:
			'The label to show the number of sprints truncated within the export view filter information',
	},
	remainingGoals: {
		id: 'portfolio-3-portfolio.app-export-view.main.view-information.filter.remaining-goals',
		defaultMessage: '+{count} {count, plural, one {more goal} other {more goals}}',
		description:
			'The label to show the number of goals truncated within the export view filter information',
	},
	remainingWarnings: {
		id: 'portfolio-3-portfolio.app-export-view.main.view-information.filter.remaining-warnings',
		defaultMessage: '+{count} {count, plural, one {more warning} other {more warnings}}',
		description:
			'The label to show the number of warnings truncated within the export view filter information',
	},
	remainingLabels: {
		id: 'portfolio-3-portfolio.app-export-view.main.view-information.filter.remaining-labels',
		defaultMessage: '+{count} {count, plural, one {more label} other {more labels}}',
		description:
			'The label to show the number of issue labels truncated within the export view filter information',
	},
	remainingStatuses: {
		id: 'portfolio-3-portfolio.app-export-view.main.view-information.filter.remaining-statuses',
		defaultMessage: '+{count} {count, plural, one {more status} other {more statuses}}',
		description:
			'The label to show the number of statuses truncated within the export view filter information',
	},
	remainingProjects: {
		id: 'portfolio-3-portfolio.app-export-view.main.view-information.filter.remaining-projects',
		defaultMessage: '+{count} {count, plural, one {more project} other {more projects}}',
		description:
			'The label to show the number of projects truncated within the export view filter information',
	},
	remainingComponents: {
		id: 'portfolio-3-portfolio.app-export-view.main.view-information.filter.remaining-components',
		defaultMessage: '+{count} {count, plural, one {more component} other {more components}}',
		description:
			'The label to show the number of components truncated within the export view filter information',
	},
	issuesWithWarnings: {
		id: 'portfolio-3-portfolio.app-export-view.main.view-information.filter.issues-with-warnings',
		defaultMessage: 'Issues with warnings',
		description:
			'The label to indicate whether the "filter issues with warnings" setting is enabled',
	},
	showFullHierarchy: {
		id: 'portfolio-3-portfolio.app-export-view.main.view-information.filter.show-full-hierarchy',
		defaultMessage: 'Showing full hierarchy',
		description: 'The label to indicate whether the "Show full hierarchy" setting is enabled',
	},
	specificIssueTriggerWithDependencyChain: {
		id: 'portfolio-3-portfolio.app-export-view.main.view-information.filter.specific-issue-trigger-with-dependency-chain',
		defaultMessage: 'Dependencies of {issueKey} (including dependency chain)',
		description:
			'Text for filter trigger when specific issue dependency with dependency chain is selected',
	},
	dateRange: {
		id: 'portfolio-3-portfolio.app-export-view.main.view-information.filter.date-range',
		defaultMessage: 'From {startDate} to {endDate}',
		description:
			'The label to indicate the date range filter issue from a given date to another. {startDate} and {endDate} are placeholders for the actual dates',
	},
	dateRangeFrom: {
		id: 'portfolio-3-portfolio.app-export-view.main.view-information.filter.date-range-from',
		defaultMessage: 'From {startDate}',
		description:
			'The label to indicate the date range filters issue from a given date onwards. {startDate} is a placeholder for the actual date',
	},
	dateRangeTo: {
		id: 'portfolio-3-portfolio.app-export-view.main.view-information.filter.date-range-to',
		defaultMessage: 'To {endDate}',
		description:
			'The label to indicate the date range filters issue up to a given date. {endDate} is a placeholder for the actual date',
	},
});
